import React from 'react'
import dynamic from 'next/dynamic'
import AppDrawer from '@components/Sidebar/AppDrawer'
import Navigation from '@components/organisms/Navigation'
import { Words } from '@containers/Words'
import { initializeApollo } from '@graphql/apolloClient'
import { GetWordCategoriesDocument } from '@services/graphcms/client'

type Props = React.ComponentProps<typeof Words>

const DynamicFooter = dynamic(import('@components/organisms/Footer'), {
  ssr: false,
})

export default function WordsPage(props: Props) {
  return (
    <>
      <AppDrawer>
        <Words wordCategories={props.wordCategories} />
        <DynamicFooter />
        <Navigation />
      </AppDrawer>
    </>
  )
}

export async function getStaticProps() {
  const apolloClient = initializeApollo()

  const nextSeoValues = {
    title: '用語集 | 塗料業界に特化した総合情報サイトのCOATAZ（コーターズ ）',
    description:
      '用語集の掲載ページです。COATAZは塗料業界に特化したニュース、製品カタログや企業情報を掲載している塗料業界の総合情報サイトです。',
    canonical: 'https://coataz.com/words',
    openGraph: {
      url: 'https://coataz.com/words',
      title: '用語集 | 塗料業界に特化した総合情報サイトのCOATAZ（コーターズ ）',
      description:
        '用語集の掲載ページです。COATAZは塗料業界に特化したニュース、製品カタログや企業情報を掲載している塗料業界の総合情報サイトです。',
    },
  }

  const { data } = await apolloClient.query({
    query: GetWordCategoriesDocument,
    variables: {
      skip: 0,
      first: 300,
    },
  })

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      wordCategories: data.wordCategories,
      nextSeo: nextSeoValues,
    },
    revalidate: 60,
  }
}
